module.exports = __webpack_public_path__ + "img/anquanjishucuoshi.dd1341bc.png";